<mat-spinner [diameter]="diameter()"/>
